// utils/API/BackendHelper/admin/questionBank.js
import ApiHelper from '../../ApiHelper';
import API_ENDPOINTS from '../../endpoints';

class QuestionBankHelper {
  /**
   * Create a single question in the question bank
   * @param {Object} questionData - Question data (course_id, question_text, options, correct_answer)
   * @returns {Promise} Created question data
   */
  async createQuestion(questionData) {
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.QUESTION_BANK.BASE, questionData);
      return response;
    } catch (error) {
      throw new Error(`Failed to create question: ${error.message}`);
    }
  }

  /**
   * Create multiple questions at once (bulk create)
   * @param {Array} questions - Array of question objects
   * @returns {Promise} Created questions data
   */
  async bulkCreateQuestions(questions) {
    try {
      const response = await ApiHelper.post(API_ENDPOINTS.ADMIN.QUESTION_BANK.BULK_CREATE, { questions });
      return response;
    } catch (error) {
      throw new Error(`Failed to bulk create questions: ${error.message}`);
    }
  }

  /**
   * Get all questions for a specific course
   * @param {string} courseId - The course ID
   * @returns {Promise} List of questions for the course
   */
  async getQuestionsByCourse(courseId) {
    try {
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN.QUESTION_BANK.BY_COURSE(courseId));
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch questions: ${error.message}`);
    }
  }

  /**
   * Update an existing question
   * @param {string} questionId - The question ID
   * @param {Object} updateData - Updated question data (question_text, options, correct_answer)
   * @returns {Promise} Updated question data
   */
  async updateQuestion(questionId, updateData) {
    try {
      const response = await ApiHelper.put(API_ENDPOINTS.ADMIN.QUESTION_BANK.BY_ID(questionId), updateData);
      return response;
    } catch (error) {
      throw new Error(`Failed to update question: ${error.message}`);
    }
  }

  /**
   * Delete a question from the question bank
   * @param {string} questionId - The question ID
   * @returns {Promise} Deletion confirmation
   */
  async deleteQuestion(questionId) {
    try {
      const response = await ApiHelper.delete(API_ENDPOINTS.ADMIN.QUESTION_BANK.BY_ID(questionId));
      return response;
    } catch (error) {
      throw new Error(`Failed to delete question: ${error.message}`);
    }
  }

  async bulkDeleteQuestions(ids) {
    try {
      const response = await ApiHelper.delete(API_ENDPOINTS.ADMIN.QUESTION_BANK.BULK_DELETE, { data: { ids } });
      return response;
    } catch (error) {
      throw new Error(`Failed to bulk delete questions: ${error.message}`);
    }
  }
}

const questionBankHelper = new QuestionBankHelper();
export default questionBankHelper;
